module.exports = "/_next/static/images/bgImageLeadership-54f64d78a2ddee512990cb4aa76c7da8.webp";